import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { FirebaseAnalytics } from "@capacitor-firebase/analytics";

/**
 * AnalyticsBootstrap — tracking de pantallas con Firebase Analytics.
 *
 * SOLO app nativa (Android/iOS): en web es no-op porque ahi ya miden el
 * gtag de GA4 y Plausible desde index.html, y el SDK web de Firebase no
 * esta inicializado para Analytics.
 *
 * App de salud: NO se manda nada que identifique al paciente (DNI, nombre,
 * estudios, protocolos). Solo el path de la ruta, y cualquier segmento que
 * contenga numeros se reemplaza por ":id" antes de enviarse.
 *
 * Los eventos automaticos (first_open, session_start, user_engagement) los
 * genera el SDK nativo solo — de ahi salen las estadisticas de descargas.
 */

const rutaAnonima = (pathname) => {
  const ruta = (pathname || "/")
    .split("/")
    .map((segmento) => (/\d/.test(segmento) ? ":id" : segmento))
    .join("/");
  return ruta === "" ? "/" : ruta;
};

const AnalyticsBootstrap = () => {
  const history = useHistory();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return undefined;

    const registrarPantalla = (pathname) => {
      FirebaseAnalytics.setCurrentScreen({
        screenName: rutaAnonima(pathname),
        screenClassOverride: "RouterPortal",
      }).catch((err) =>
        console.warn("AnalyticsBootstrap setCurrentScreen fallo:", err)
      );
    };

    registrarPantalla(history.location.pathname);
    const unlisten = history.listen((location) =>
      registrarPantalla(location.pathname)
    );
    return unlisten;
  }, [history]);

  return null;
};

export default AnalyticsBootstrap;
